import { Link, useLocation, Outlet, Navigate } from 'react-router-dom';

const navigationItems = [
  {
    id: 'contexts',
    label: 'Contextos Ativáveis',
    path: '/app/settings/content/contexts',
  },
  {
    id: 'brands-sectors',
    label: 'Marcas e Setores',
    path: '/app/settings/content/brands-sectors',
  },
  {
    id: 'creators',
    label: 'Creators Fonte',
    path: '/app/settings/content/creators',
  },
];

export default function ContentAdministration() {
  const location = useLocation();

  if (location.pathname === '/app/settings/content') {
    return <Navigate to="/app/settings/content/contexts" replace />;
  }

  return (
    <div>
      <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-12 gap-4">
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold text-gray-900">Administração de conteúdos</h2>
          <p className="text-muted-foreground">Gerencie os conteúdos e configurações do sistema.</p>
        </div>
      </div>

      <div className="mb-6 overflow-x-auto">
        <nav className="flex space-x-8 min-w-max">
          {navigationItems.map((item) => (
            <Link
              key={item.id}
              to={item.path}
              className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
                location.pathname === item.path
                  ? 'border-black text-black'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
